import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowBack, BarChart } from '@mui/icons-material';

const StatisticsPage: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-background transition-colors">
      <div className="max-w-7xl mx-auto px-6 py-8">
        <button
          onClick={() => navigate('/dashboard')}
          className="flex items-center space-x-2 text-sm text-gray-600 dark:text-gray-400 hover:text-gray-900 dark:hover:text-gray-200 mb-6 transition-colors"
        >
          <ArrowBack style={{ width: '16px', height: '16px' }} />
          <span>Geri</span>
        </button>
        
        <div className="flex items-center space-x-3 mb-6">
          <BarChart style={{ width: '32px', height: '32px' }} className="text-gray-900 dark:text-white" />
          <h1 className="text-4xl md:text-5xl font-bold tracking-tight text-gray-900 dark:text-white">İstatistikler</h1>
        </div>
        
        <div className="bg-white dark:bg-gray-900 rounded-xl p-4 sm:p-8 border border-gray-200 dark:border-gray-800">
          <p className="text-gray-600 dark:text-gray-400">
            İstatistikler sayfası yakında eklenecek.
          </p>
        </div>
      </div>
    </div>
  );
};

export default StatisticsPage;
